import http from '@/utils/http';
const prefix = '/ysr-h5-app';

export interface IChannelId {
  channelId: string;
}
export interface IObjStr {
  [propName: string]: string;
}
export interface IObjStrNumObj {
  [propName: string]: string | number | IObjStr;
}
export interface IObjStrNum {
  [propName: string]: string | number;
}

/**根据渠道ID查看渠道详情*/
export const getChannelDetail = (data: IChannelId): Promise<IObjStrNumObj> =>
  http.post<IObjStrNumObj>(prefix + '/web/channel/detail', data);
/**根据显示位置获取弹窗配置信息 49、H5补充留资页一拦弹窗 50、H5落地页一拦弹窗 51、H5信贷留资页一拦弹窗*/
export const getPopWindowByLocation = (data: IObjStrNum): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/creditConversionControl/getPopWindowByLocation', data);

export const pageVisit = (): Promise<IObjStr> => http.post<IObjStr>(prefix + '/web/page/visit');
export const pageGetPopWindowByLocation = (data: IObjStrNum): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/page/getPopWindowByLocation', data);

/**凭证登录接口*/
export const voucherLogin = (par: IObjStrNum): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/user/voucherLogin', par);

/* 20230428 - 全流程埋点 - 登录 */
export const operateBuried = (data: IObjStr): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/buried/user/operation', data);

export const operateBuriedNoToken = (data: any): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/buried/user/visit', data);

/**获取用户基本信息*/
export const baseUserInfo = (): Promise<IObjStr> =>
  http.post<IObjStr>(`${prefix}/web/user/baseUserInfo`);

/** 上报clickId */
export const clickConversionUpClickId = (data: IObjStr): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/h5/clickConversion/upClickId', data);

/**渠道落地页IP归因记录*/
export const channelPageIpRecord = (): Promise<IObjStr> =>
  http.get<IObjStr>(prefix + '/web/channel/channelPageIpRecord');
